// Scent / Bead Color pickers (snippets/mpp-freshie-choices.liquid).
// They're cart-line properties, so Dawn's product form doesn't know they're
// required: block the add-to-cart submit until each one is picked.
if (!customElements.get('mpp-freshie-choices')) {
  const chosen = (group) => {
    const input = group.querySelector('input:checked, select');
    return Boolean(input && input.value);
  };

  customElements.define(
    'mpp-freshie-choices',
    class MppFreshieChoices extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          const group = event.target.closest('[data-mpp-choice]');
          if (!group) return;
          const label = group.querySelector('[data-mpp-selected]');
          if (label) label.textContent = event.target.value;
          group.querySelector('.mpp-choices__error').hidden = true;
        });
      }

      // true when everything is picked; otherwise shows the errors and focuses the first gap
      check() {
        const missing = [...this.querySelectorAll('[data-mpp-choice]')].filter((group) => !chosen(group));
        missing.forEach((group) => (group.querySelector('.mpp-choices__error').hidden = false));
        if (missing.length) {
          missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          missing[0].querySelector('input, select').focus({ preventScroll: true });
        }
        return missing.length === 0;
      }
    }
  );

  // Capture on document runs before product-form's own submit listener.
  document.addEventListener(
    'submit',
    (event) => {
      // getAttribute, not form.id: product forms have an input named "id" that shadows it
      const formId = event.target.getAttribute('id');
      if (!formId) return;
      const choices = document.querySelectorAll(`mpp-freshie-choices[data-form-id="${CSS.escape(formId)}"]`);
      if ([...choices].map((el) => el.check()).every(Boolean)) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
}
